export const ReferFriendEnum = {
    InviteFriend: 0,
    StatusTracking: 1,
}

export const ReferFriendStatusEnum = {
    Pending: 1,
    ToBeClaimed: 2,
    Claimed: 3,
    Failed: 4
}
export const ReferFriendTriggerEnum = {
    Invitation: 1,
    Registration: 2,
    Verification: 3,
    Deposit: 4,
    Fail: 5
}

export const ReferFriendValidationTypes = {
    Registration: 1,
    Verification: 2,
    Deposit: 3
}

export const BonusCampaignWalletType = {
    Used: 1,
    UnUsed: 2,
    Rollover: 3
}

export const ReferralProgramInviteType = {
    SMS: 1,
    Email: 2,
    Other: 3
}